<template>
  <table class="reports-table">
    <thead >
      <slot name="columns">
        <th v-for="column in columns">{{column}}</th>
      </slot>
    </thead>
    <tbody>
    <tr v-for="(item, rowIdx) in data" :key="rowIdx">
      <td v-for="(column, colIdx) in columns" :key="colIdx" :class="{
        'has-error': hasError(item, column)
      }">
        {{  getCellValue(item, column) }}
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'l-table',
    props: {
      columns: Array,
      data: Array
    },

    methods: {
      hasError (item, column) {
        if(!item || !column) return false
        return  column === 'Ошибки' && item[column] > 0
      },
      getCellValue(item, column) {
        return item[column] === undefined ? '' : item[column];
      },
      hasValue (item, column) {
        return item[column] !== undefined
      },
      itemValue (item, column) {
        return item[column]
      }
    }
  }
</script>
<style lang="scss">
.reports-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  color: #606266;
}
.reports-table th,
.reports-table td {
  border: 0.5px solid #ededed;
  text-align: left;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 10px;

}
.reports-table th {
  background: #f5f5f5;
  font-weight: 400;
  color: #90AAB7;
  font-size: 12px;
  text-transform: uppercase;
}

.has-error {
  color: red;
  /*background: rgba(246, 238, 238, 0.68);*/
  font-size: 16px;
}

</style>
